export const enum ComponentOrigins {
  BOOKMARKS_LIST = 'bookmarks-list',
  NEWS_LIST = 'news-list',
  ONE_NEWS = 'one-news',
}
